export const GeoEvent = {
	ROLLOUT_EVALUATED: 'geo.rollout.evaluated',
	VERIFICATION_STARTED: 'geo.verification.started',
	VERIFICATION_COMPLETED: 'geo.verification.completed',
	LOBBY_LOADED: 'geo.lobby.loaded',
	MONITOR_LOCATION_CHECKED: 'geo.monitor.location_checked',
	MONITOR_SIGNED_OUT: 'geo.monitor.signed_out',
	CONSENT_SHOWN: 'geo.consent.shown',
	CONSENT_ACCEPTED: 'geo.consent.accepted',
	CONSENT_DECLINED: 'geo.consent.declined',
	CONSENT_SKIPPED: 'geo.consent.skipped',
	CONSENT_ENDPOINT_FAILED: 'geo.consent.endpoint_failed',
	CONSENT_LOGOUT: 'geo.consent.logout',
	GUIDANCE_SHOWN: 'geo.guidance.shown',
	GUIDANCE_OUTCOME: 'geo.guidance.outcome',
	GUIDANCE_RETRY: 'geo.guidance.retry',
	MONITOR_FAILURE_SUPPRESSED: 'geo.monitor.failure_suppressed',
	PROTECTION_STARTED: 'geo.protection.started',
	PROTECTION_ENDED: 'geo.protection.ended',
	PROTECTION_HOLD_STARTED: 'geo.protection.hold_started',
	PROTECTION_HOLD_ENDED: 'geo.protection.hold_ended',
	LOCATION_RECHECK_STARTED: 'geo.location_recheck.started',
	MANUAL_RECHECK_REQUESTED: 'geo.manual_recheck.requested',
	LOCATION_RECHECK_JOINED: 'geo.location_recheck.joined',
} as const

export interface GeoAnalyticsEvent {
	name: string
	data: Record<string, unknown>
	timestamp: number
}

export type GeoAnalyticsSink = (event: GeoAnalyticsEvent) => void

const sinks: GeoAnalyticsSink[] = []
let context: Record<string, unknown> = {}

export function registerGeoSink(sink: GeoAnalyticsSink): void {
	sinks.push(sink)
}

export function setGeoContext(ctx: Record<string, unknown>): void {
	context = { ...context, ...ctx }
}

export function clearGeoContext(): void {
	context = {}
}

export function emitGeoEvent(name: string, data: Record<string, unknown>): void {
	const event: GeoAnalyticsEvent = { name, data: { ...context, ...data }, timestamp: Date.now() }
	for (const sink of sinks) {
		try {
			sink(event)
		} catch (error) {
			console.error(`[geo-analytics] Sink failed for ${name}`, error)
		}
	}
}

export function clearGeoSinks(): void {
	sinks.length = 0
}
